//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "sup-overview",
  props:['baseInfo','contactList','purorgList', 'supManageInfo', 'reserved_1'],
  data(){
    return{
      show:'base'
    }
  },
  methods:{
    select(str){
      this.show = str;
    }
  }
}



// WEBPACK FOOTER //
// ./src/page/supplier/view/sup-overview.vue